import { createApi } from '@reduxjs/toolkit/query/react'
import type { SportsbookLaunchRequest, SportsbookLaunchResponse, SportsbookRefreshTokenResponse, SportsbooksListApiResponse } from '@/types/sportsbook'
import { playerBaseQuery } from './playerBaseQuery'

export const sportsbookApi = createApi({
	reducerPath: 'sportsbookApi',
	baseQuery: playerBaseQuery,
	tagTypes: ['Sportsbooks'],
	endpoints: (builder) => ({
		getSportsbooks: builder.query<SportsbooksListApiResponse, void>({
			query: () => '/sportsbooks/list',
			providesTags: ['Sportsbooks'],
		}),
		launchSportsbook: builder.query<SportsbookLaunchResponse, SportsbookLaunchRequest>({
			query: (params) => ({
				url: '/sportsbooks/launch',
				params,
			}),
		}),
		refreshSportsbookToken: builder.query<SportsbookRefreshTokenResponse, string>({
			query: (sessionId) => `/sportsbooks/refresh-token/${sessionId}`,
		}),
	}),
})

export const { useGetSportsbooksQuery, useLazyLaunchSportsbookQuery, useLazyRefreshSportsbookTokenQuery } = sportsbookApi
